//#region Libraries
//#endregion
//#region Styles
import { 
    Container,
    TDef } from "components/CustomTableList/components/TableListItem/ListItem/styles";
//#endregion
//#region Icons
import { 
    Cell, 
    NameCell, 
    DateCell, 
    CapacityCell, 
    AddressReferenceCell,
    DetailsCell } from "./styles";
//#endregion

const TDEF_CONTENT_PROPS = {
    margin: "1px 0"
};

const TableListItem = ({
    name,
    availableSports,
    minCapacity,
    maxCapacity,
    address,
    reference,
    details,
    date,
    changes
}) => {
    //#region Functions
    const getClassName = fieldIsChanged => {
        const classList = ["small", "ellipsis"];
        fieldIsChanged && classList.push("changed");
        return classList.join(" ");
    }
    const getPropsForCell = fieldIsChanged => {
        return {
            ...TDEF_CONTENT_PROPS,
            className: getClassName(fieldIsChanged)
        };  
    }
    //#endregion
    return (
        <Container>
            <TDef>
                <NameCell {...getPropsForCell(changes.name)}>
                    <h5 title={name}>{name}</h5>
                </NameCell>
            </TDef>
            <TDef>
                <Cell {...getPropsForCell(changes.availableSports)}>
                    <h5 title={availableSports}>{availableSports}</h5>
                </Cell>
            </TDef>
            <TDef>
                <CapacityCell {...getPropsForCell(changes.minCapacity)}>
                    <h5 title={minCapacity}>{minCapacity}</h5>
                </CapacityCell>
            </TDef>
            <TDef>
                <CapacityCell {...getPropsForCell(changes.maxCapacity)}>
                    <h5 title={maxCapacity}>{maxCapacity}</h5>
                </CapacityCell>
            </TDef>
            <TDef>
                <AddressReferenceCell {...getPropsForCell(changes.address)}>
                    <h5 title={address}>{address}</h5>
                </AddressReferenceCell>
            </TDef>
            <TDef>
                <AddressReferenceCell {...getPropsForCell(changes.reference)}>
                    <h5 title={reference}>{reference}</h5>
                </AddressReferenceCell>
            </TDef>
            <TDef>
                <DetailsCell {...getPropsForCell(changes.details)}>
                    <h5 title={details}>{details || "-"}</h5>
                </DetailsCell>
            </TDef>
            <TDef>
                <DateCell {...getPropsForCell()}>
                    <h5 title={date}>{date}</h5>
                </DateCell>
            </TDef>
        </Container>
    );
}

export default TableListItem;